export default __webpack_public_path__ + "static/android-application-development-company-peerbits-8f20a20abd0a8fd5cdf881996a6e5bb8.png";